import React, { FC, HTMLInputTypeAttribute, ReactNode, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { Controller, Control, FieldErrors } from 'react-hook-form'

import { ReactComponent as ConfirmIcon } from 'assets/images/checked-outlined.svg'
import { ReactComponent as ClosedEyeIcon } from 'assets/images/closed-eye.svg'
import { ReactComponent as OpenEyeIcon } from 'assets/images/open-eye.svg'
import { ReactComponent as UserIcon } from 'assets/images/userOutlined.svg'
import { ReactComponent as EditIcon } from 'assets/images/edit.svg'

import styles from './styles.module.scss'

interface IProps {
  name: string;
  placeholder?: string;
  label?: string
  disabled?: boolean,
  control: Control<any>;
  errors?: FieldErrors<any>,
  type?: HTMLInputTypeAttribute,
  iconType?: TIcon
  confirmed?: boolean
  withErrorMessage?: boolean
  limit?: number,
}

type TIcon = 'confirm' | 'password' | 'user' | 'edit'

export const InputField: FC<IProps> = (
  {
    name,
    control,
    errors,
    placeholder,
    label,
    disabled,
    type = 'text',
    iconType,
    confirmed,
    withErrorMessage,
    limit
  }) => {
  const [visible, setVisible] = useState(false)

  const handleChangeVisibility = () => {
    setVisible(prev => !prev)
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => {
        const { value } = field
        const length = value.length

        return (
          <div className={styles.container}>
            <input
              {...field}
              id={name}
              className={cn(styles.inputField, {
                [styles.inputFieldError]: errors && errors[name],
                [styles.inputFieldWithIcon]: iconType,
                [styles.inputFieldWithLabel]: label
              })}
              type={(type === 'password' && visible) ? 'text' : type}
              placeholder={placeholder}
              disabled={disabled}
              autoComplete={type === 'password' ? 'off' : undefined}
            />

            {label ? <div className={styles.label}>{label}</div> : null}

            {limit
              ? <div className={cn(styles.noteLength, {
                [styles.noteLengthOverMax]: length > (limit ? limit : 500)
              })}>
                {length}/{limit ? limit : 500}
              </div>
              : null}

            {iconType
              ? <button className={styles.iconBox}
                        type="button"
                        style={iconType === 'password' ? { pointerEvents: 'unset' } : {}}
                        onClick={handleChangeVisibility}
              >
                {iconType === 'confirm'
                  ? <ConfirmIcon className={cn(styles.confirmIcon, {
                    [styles.confirmedIcon]: confirmed
                  })}/> : null}
                {iconType === 'user'
                  ? <UserIcon className={styles.userIcon}/>
                  : null}
                {iconType === 'password'
                  ? visible
                    ? <OpenEyeIcon className={styles.passwordIcon}/> : <ClosedEyeIcon className={styles.passwordIcon}/>
                  : null}
                {iconType === 'edit'
                  ? <EditIcon className={styles.editIcon}/>
                  : null}
              </button>
              : null}

            {withErrorMessage && errors && errors[name]
              ? <div className={styles.errorMessage}>{errors[name]?.message as string || ''}</div>
              : null}

          </div>
        )
      }}
    />
  )
}
